import React, { useState } from 'react';
import { Box, TextField } from '@mui/material'; 

interface IListingInteractionTypesNameCellProps {
  name: string;
  index: number;
  onNameChange: (index: number, newName: string) => void;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const ListingInteractionTypesNameCell: React.FC<IListingInteractionTypesNameCellProps> = ({ name: initialName, index, onNameChange, onFocus }) => {
  const [name, setName] = useState<string>(initialName);
  
  const handleBlur = () => {
    onNameChange(index, name);
  };

  return (
    <Box>
      <TextField
        fullWidth
        placeholder="Listing Interaction Name"
        size="small"
        value={name ?? ''}
        onChange={event => setName(event.target.value)}
        onBlur={handleBlur}
        onFocus={onFocus}
      />
    </Box>
  );
};
